import { Tech } from "../../pages/ProjectsPage/projects-data";
import { StyledTechIcon } from "./styles";

import html from "../../assets/techIconsPng/html5.png";
import css from "../../assets/techIconsPng/css.png";
import js from "../../assets/techIconsPng/js.png";
import nodejs from "../../assets/techIconsPng/nodejs.png";
import reactjs from "../../assets/techIconsPng/reactjs.png";
import typescript from "../../assets/techIconsPng/typescript.png";
import postgresql from "../../assets/techIconsPng/postgresql.png";
import express from "../../assets/techIconsPng/express.png";

const imgs = {
  html: html,
  css: css,
  js: js,
  nodejs: nodejs,
  reactjs: reactjs,
  typescript: typescript,
  postgresql: postgresql,
  express: express,
};

interface ITechIconProps {
  tech: Tech;
}

const TechIcon = ({ tech }: ITechIconProps) => {
  return (
    <StyledTechIcon>
      <div className="icon-tooltip">{tech}</div>
      <img className="stack-icon-img" src={imgs[tech]} alt={`${tech} icon`} />
    </StyledTechIcon>
  );
};

export default TechIcon;
